import { MotionConfig } from "framer-motion";
import { useTranslation } from "react-i18next";
import Faq from "../shared/Faq";
import FeaturesStack from "../shared/FeaturesStack";
import LandingFooter from "../shared/LandingFooter";
import LandingNav, { type NavLink } from "../shared/LandingNav";
import type { LandingData } from "../types";
import HeroC from "./HeroC";
import PlansA from "../a/PlansA";
import Tape from "./Tape";
import "./landing-c.css";

// Story Stack: the landing as a run of Instagram stories on the brand gradient.
export default function LandingC({ data }: { data: LandingData }) {
  const { t } = useTranslation();
  const links: NavLink[] = [
    { href: "#features", label: t("ui.landing.nav.features") },
    { href: "#plans", label: t("ui.landing.nav.plans") },
    { href: "#faq", label: t("ui.landing.nav.faq") },
  ];
  return (
    // "user": spring lifts and swaps jump straight to their end state under reduced motion
    <MotionConfig reducedMotion="user">
      <div className="relative isolate min-h-[100dvh] overflow-x-clip">
        <LandingNav data={data} links={links} heroId="hero" />
        <main>
          <HeroC data={data} id="hero" />
          <Tape />
          <FeaturesStack variant="c" />
          {/* the owner wanted A's glass plan picker here too, so both designs share it */}
          <PlansA data={data} />
          <Faq variant="accordion" className="pb-24 pt-8 md:pt-12" />
        </main>
        <LandingFooter data={data} />
      </div>
    </MotionConfig>
  );
}
